import { Injectable, OnDestroy } from '@angular/core';
import { CookiesService } from './cookies.service';

@Injectable({
	providedIn: 'root',
})
export class StateTabsService implements OnDestroy {
	private readonly _stateTabKey = 'dirty_tabs_session';
	// Guardamos el ID en una propiedad privada para no depender siempre de window.name
	private readonly _tabId: string;

	constructor(private readonly _cookiesService: CookiesService) {
		// 1. Generar o recuperar el ID de la pestaña
		if (!window.name || !window.name.startsWith('tab_')) {
			window.name = `tab_${Math.random().toString(36).substring(2, 9)}_${Date.now()}`;
		}
		this._tabId = window.name;

		// 2. Escuchar cuando se cierra la pestaña para limpiar su estado automáticamente
		window.addEventListener('beforeunload', () => this._handleTabClosing());
	}

	/**
	 * El componente avisa si tiene cambios pendientes.
	 * @param hasChanges true si hay datos sin guardar, false si ya se guardó.
	 */
	setChangesPending(hasChanges: boolean): void {
		const state = this._getGlobalState();

		if (hasChanges) {
			state[this._tabId] = true;
		} else {
			delete state[this._tabId];
		}

		this._saveState(state);
	}

	/**
	 * Verifica si ALGUNA pestaña del ecosistema Sintad tiene cambios sin guardar.
	 */
	hasAnyUnsavedChanges(): boolean {
		const state = this._getGlobalState();
		return Object.keys(state).length > 0;
	}

	/**
	 * Limpia el estado de la pestaña actual (útil para el Logout manual)
	 */
	clearCurrentTabState(): void {
		this.setChangesPending(false);
	}

	private _getGlobalState(): Record<string, boolean> {
		try {
			const raw = this._cookiesService.getItem(this._stateTabKey);
			if (!raw || raw === 'null' || raw === 'undefined') return {};
			return JSON.parse(raw) as Record<string, boolean>;
		} catch (e) {
			return {};
		}
	}

	private _saveState(state: Record<string, boolean>): void {
		if (Object.keys(state).length > 0) {
			this._cookiesService.setItem(this._stateTabKey, JSON.stringify(state));
		} else {
			this._cookiesService.removeItem(this._stateTabKey);
		}
	}

	private _handleTabClosing(): void {
		this.clearCurrentTabState();
	}

	ngOnDestroy(): void {
		window.removeEventListener('beforeunload', () => this._handleTabClosing());
	}
}
